import { render, staticRenderFns } from "./Datasource.vue?vue&type=template&id=35f01b3e&scoped=true&"
import script from "./Datasource.vue?vue&type=script&lang=js&"
export * from "./Datasource.vue?vue&type=script&lang=js&"
import style0 from "./Datasource.vue?vue&type=style&index=0&id=35f01b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f01b3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VTooltip})
